import { APP_JSON, ENROLLCARD_NAMESPACES } from '../../constants/common-enums';
import fetchReq from '../../helpers/fetch';
import getAppInstance from '../../helpers/get-app-instance';
import isEmptyObject from '../../helpers/is-empty-object';
import isEmptyString from '../../helpers/is-empty-string';
import CONFIG from '../../settings';

const { SRC, SRC_XO } = ENROLLCARD_NAMESPACES;

const enrollCardAPI = {
  /**
   * @param {object} requestParam
   * @param {string} apikey
   * @returns {object} response object
   */
  enrollCard: (requestParam, apikey) => {
    // Use SRC namespace when access token not present
    const enrollCardSRCDataUri = CONFIG.application.api.enrollCard(SRC);
    let url = `${enrollCardSRCDataUri}?apikey=${apikey}`;
    const {
      accessToken,
      dpaTransactionOptions,
      encryptedCard,
      encryptedConsumer,
      intentId,
      payloadTypeIndicatorCheckout,
      sessionId,
      srcDpaId,
      srcCorrelationId
    } = requestParam;
    const requestPayload = {
      appInstance: {
        userAgent: getAppInstance()
      },
      encryptedCard,
      encryptedConsumer,
      payloadTypeIndicatorCheckout,
      srcClientId: apikey
    };

    const headers = {
      Accept: APP_JSON,
      'Content-Type': APP_JSON,
      'X-THMID': sessionId,
      dfpSessionId: sessionId
    };

    /* Pass accessToken only if available; BE not validating for undefined cases
     * enrollcard api end point needs to change when access token is present.
     * SRC-XO namespace is for when access token present
    */
    if (accessToken) {
      headers.access_token = accessToken;
      const enrollCardSRCXODataUri = CONFIG.application.api.enrollCard(SRC_XO);
      url = `${enrollCardSRCXODataUri}?apikey=${apikey}`;
    }

    if (intentId) {
      url = `${url}&intentId=${intentId}`;
    }

    //for returning user BE will able to pull this data using accessToken
    if (!isEmptyString(encryptedConsumer)) {
      requestPayload.encryptedConsumer = encryptedConsumer;
    }

    if (!isEmptyString(srcCorrelationId)) {
      requestPayload.srcCorrelationId = srcCorrelationId;
    }

    //srcDpaId is optional as per EMV
    if (!isEmptyString(srcDpaId)) {
      requestPayload.srcDpaId = srcDpaId;
    }

    if (!isEmptyObject(dpaTransactionOptions)) {
      requestPayload.dpaTransactionOptions = dpaTransactionOptions;
    }

    const options = {
      body: requestPayload,
      headers,
      method: 'POST',
      url
    };
    return fetchReq(options);
  }
};

export default enrollCardAPI;
